// Quando torno indietro allo step della creazione account e poi vado avanti di uno
// c'e' un problema perche va in position absolute e si smarona

class RequestQuote {
  constructor() {
    if (!document.querySelector(".request-quote")) return;

    Object.assign(this, {
      container: document.querySelector(".request-quote"),
      user: {},
      currentStep: 1,
      lastStep: 4,
      hasLoaderActive: true,
      next: true,
      titleBanner: document.querySelector(".title-banner"),
      subtitleBanner: document.querySelector(".subtitle-banner"),
      skipReferrer: false,
    });

    // Assign transition for all the steps
    document
      .querySelectorAll(".step")
      .forEach((el) => (el.style.transition = "opacity .7s ease-out"));

    this.init();
  }

  async init() {
    this.events();
    await this.tryToAuthenticate();

    this.setInitialStep();
    this.goToCorrectStep();
  }

  events() {
    document
      .querySelectorAll(".next-step")
      .forEach((el) =>
        el.addEventListener("click", this.incrementStep.bind(this))
      );

    document
      .querySelectorAll(".back-step")
      .forEach((el) =>
        el.addEventListener("click", this.decrementStep.bind(this))
      );

    document
      .querySelector(".next-step-no-validate")
      .addEventListener("click", this.incrementStep.bind(this));

    document
      .querySelector(".final-step")
      .addEventListener("click", this.send.bind(this));

    document
      .querySelector(".init-step")
      .addEventListener("click", this.goToFirstPage.bind(this));

    document
      .querySelector(".request-quote .multiply-block")
      .addEventListener("change", this.handleNumberChange.bind(this));

    document.body.addEventListener("click", this.controls.bind(this));

    $(".request-quote [data-validationrules]").on(
      "input change",
      this.singleValidation.bind(this)
    );
  }

  normalizeDomain(domain) {
    return domain
      .replace(/https?:\/\//, "")
      .replace(/www\./, "")
      .replace(/(?:\.)([^.]*$)/, "$1")
      .replace(/\/$/, "");
  }

  // 0 Agenzia ([[6, False, [2]]]),
  // 1 Consulente ([[6, False, [4]]]),
  // 2 Altro ([[6, False, [5]]]),
  // 3 Proprietario ecommerce ([[6, False, [6]]])
  // 4 Voglio segnalare una referenza
  getCategoryId(id = "") {
    switch (id) {
      case 0:
        return [[6, false, [2]]];
      case 1:
        return [[6, false, [4]]];
      case 2:
        return [[6, false, [5]]];
      case 3:
        return [[6, false, [6]]];
    }
  }

  getFormData() {
    return $("#quote").serializeObject();
  }

  printMarkup() {
    const formData = this.getFormData();

    this.printEcommerce(formData);
    this.printReference(formData);
  }

  printReference(formData) {
    const referenceClone = document
      .querySelector(".o-reference-template")
      .cloneNode(true);

    $(referenceClone).removeClass("hidden");
    $(referenceClone).removeClass("o-reference-template");
    $(referenceClone).addClass("o-reference");

    formData.referrer.forEach((p) => {
      if (p.domains.length > 0 && p.domains[0].length <= 0) return;

      const referenceTemplate = document.querySelector(
        ".o-reference-item-template"
      );

      const templ = referenceTemplate.cloneNode(true);
      $(templ).removeClass("o-reference-item-template");
      $(templ).removeClass("hidden");

      // $(templ)
      //   .find(".o-referent-visit")
      //   .text(p.pageviews_max);

      $(templ)
        .find(".o-referent-referent")
        .text(p.name);

      $(templ)
        .find(".o-divider")
        .removeClass("hidden");

      $(templ)
        .find(".o-referent-sitename")
        .html(p.domains.join("</br>"));

      $(referenceClone).append(templ);
    });

    if (
      formData.referrer[0].domains.length > 0 &&
      formData.referrer[0].domains[0].length <= 0
    )
      return;

    $(".o-reference").replaceWith(referenceClone);
  }

  printEcommerce(formData) {
    const ecommerceClone = document
      .querySelector(".o-ecommerce-template")
      .cloneNode(true);

    $(ecommerceClone).removeClass("hidden");
    $(ecommerceClone).removeClass("o-ecommerce-template");
    $(ecommerceClone).addClass("o-ecommerce");

    const selectSei = document.querySelector("select[name='sei']");
    $(".o-sei").text(selectSei.options[selectSei.selectedIndex].text);

    const text = $(ecommerceClone)
      .find(".o-numero_ecommerce")
      .data("title");

    $(ecommerceClone)
      .find(".o-numero_ecommerce")
      .text(text.replace("{n}", formData.ecommerce_number));

    formData.plan.forEach((p) => {
      const ecommerceTemplate = document.querySelector(
        ".o-ecommerce-item-template"
      );

      const templ = ecommerceTemplate.cloneNode(true);
      $(templ).removeClass("o-ecommerce-item-template");
      $(templ).removeClass("hidden");

      $(templ)
        .find(".o-visit")
        .text(p.pageviews_max);

      $(templ)
        .find(".o-sitename")
        .html(p.domains.join("</br>"));

      $(ecommerceClone).append(templ);
    });

    $(".o-ecommerce").replaceWith(ecommerceClone);
  }

  async send(e) {
    $(e.target)
      .parent(".button-with-loader")
      .addClass("button--loading");

    const formData = this.getFormData();

    delete formData.ecommerce_number;

    formData.plan = formData.plan.reduce((acc, current) => {
      const normalizeDomain = this.normalizeDomain(current.domains[0]);
      acc[normalizeDomain] = {
        ...current,
        pageviews_max: +current.pageviews_max.replace(/[\.,]/g, ""),
      };
      return acc;
    }, {});

    if (formData.sei) {
      formData.partner.category_id = this.getCategoryId(+formData.sei);
    }

    delete formData.sei;

    formData.sirio_order = true;

    if (formData.newsletter) {
      formData.newsletter = true;
    } else {
      formData.newsletter = false;
    }

    if (this.user.auth) {
      // delete formData.partner;
      formData.partner_id = this.user.user.res_partner_id;
    }

    if (this.skipReferrer) {
      delete formData.referrer;
    } else {
      // Normalize referrer_name
      formData.referrer = formData.referrer.map((item) => {
        item.referrer_name = this.normalizeDomain(item.domains[0]);

        // item.pageviews_max = +item.pageviews_max.replace(/[\.,]/g, "");
        return item;
      });
    }

    try {
      const response = await fetch(
        "https://api.sirio.chiron.ai/api/v1/price_quotation",
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            // "X-Authorization":
            //   "Bearer CXgvelv5zSIp3NZ5RLDkiHtB81AG2elRCvSUfBIRvwBxYkejr0Npn4cb4Y0tqdvrmksA5nsBz2eHB1k3",
          },
          body: JSON.stringify({
            lang: window.ortica.lang,
            vals: formData,
          }),
        }
      );

      const json = await response.json();

      $(e.target)
        .parent(".button-with-loader")
        .removeClass("button--loading");

      this.currentStep++;
      this.goToCorrectStep();

      console.log(json);
    } catch (e) {
      console.log(e);

      $(e.target)
        .parent(".button-with-loader")
        .removeClass("button--loading");

      alert("Something went wrong!!");
    }
  }

  controls(e) {
    if (e.target.parentNode.classList.contains("multiply-input-block")) {
      if (e.target.classList.contains("plus")) {
        this.multiplyInput(e);
      }

      if (e.target.classList.contains("minus")) {
        this.removeInput(e);
      }
    }

    if (e.target.parentNode.classList.contains("multiply-block")) {
      if (e.target.classList.contains("plus")) {
        this.multiplyElements(e);
      }
      if (e.target.classList.contains("minus")) {
        this.removeElements(e);
      }
    }
  }

  multiplyInput(e) {
    const parent = e.target.closest(`.input-block`);
    const clone = parent.cloneNode(true);
    const index = +clone.querySelector("input").name.match(/\d+/);

    this.normalizeInput(clone, index);

    $(clone)
      .find(".minus")
      .removeClass("hidden");

    $(clone).insertAfter(parent);
  }

  removeInput(e) {
    const parent = e.target.closest(`.input-block`);
    parent.remove();
  }

  handleNumberChange(e) {
    const value = +e.target.value;
    const blocks = document.querySelectorAll(
      `.step-${this.currentStep}-multiple`
    );
    const totalBlocks = blocks.length;
    const lastBlock = blocks[blocks.length - 1];

    // Add a block
    if (totalBlocks < value) {
      for (let i = totalBlocks; value > i; i++) {
        const blocks = document.querySelectorAll(
          `.step-${this.currentStep}-multiple`
        );
        const lastBlock = blocks[blocks.length - 1];

        const clone = lastBlock.cloneNode(true);
        const inputBlocks = clone.querySelectorAll(".input-block");
        // Remove inputs blocks if more than one when we clone
        if (inputBlocks.length > 1) {
          inputBlocks.forEach((block, index) => {
            if (index > 0) {
              block.remove();
            }
          });
        }
        this.normalizeInput(clone, i);

        $(clone).insertAfter(lastBlock);
      }
      // Remove a block
    } else if (totalBlocks > value) {
      for (let j = totalBlocks; j > value; j--) {
        blocks[j - 1].remove();
      }
    }
  }

  multiplyElements(e) {
    const parent = e.target.closest(`.step-${this.currentStep}-multiple`);
    // const parent = e.target.closest(`.step-2-multiple`);

    const clone = parent.cloneNode(true);

    const inputBlocks = clone.querySelectorAll(".input-block");
    // Remove inputs blocks if more than one when we clone
    if (inputBlocks.length > 1) {
      inputBlocks.forEach((block, index) => {
        if (index > 0) {
          block.remove();
        }
      });
    }

    const index = document.querySelectorAll(
      `.step-${this.currentStep}-multiple`
    ).length;

    this.normalizeInput(clone, index);

    $(clone)
      .find(".minus")
      .removeClass("hidden");

    $(clone).insertAfter(parent);
  }

  removeElements(e) {
    const parent = e.target.closest(`.step-${this.currentStep}-multiple`);
    parent.remove();
  }

  normalizeInput(clone, index) {
    const inputs = clone.querySelectorAll("input");

    inputs.forEach((input) => {
      if (input.type === "checkbox") {
        input.checked = false;
        input.id = `${input.id}-1`;

        input.parentElement.querySelector("label").htmlFor =
          input.parentElement.querySelector("label").htmlFor + "-1";

        return;
      }

      // const index = +input.name.match(/\d/)[0];
      input.name = input.name.replace(/\d/, index);

      if (input.min) {
        input.value = input.min;
        $(input).numSlider();
      } else {
        input.value = "";
      }
    });
  }

  goToFirstPage() {
    if (this.user.auth) this.currentStep = 1;
    else this.currentStep = 1;

    const step = this.user.auth ? ".step-1" : ".step-1";

    this.animate(...[".step-3", step]);
  }

  isValid(value, rules) {
    let valid = true;

    const messages = [];

    if (rules.required) {
      valid = valid && value && value.length > 0;

      if (!valid) {
        messages.push(rules.required[1]);
      }
    }

    if (rules.test && value) {
      const regexp = new RegExp(rules.test[0]);

      valid = valid && regexp.test(value);

      if (!valid) {
        messages.push(rules.test[1]);
      }
    }

    return [valid, messages];
  }

  handleErrorMessage(valid, input, messages) {
    const parentContainer = input.closest(".relative");

    $(parentContainer)
      .find(".error-message")
      .remove();

    if (valid) return;

    const markup = `<span class="error-message">${messages.join(
      "</br>"
    )}</span>`;

    $(parentContainer).append(markup);
  }

  singleValidation(e) {
    const input = e.target;
    const rules = $(input).data("validationrules");
    let value;

    // empty don't need to do anyting
    if (Array.isArray(rules) || !rules) return [true, []];

    if (input.nodeName.toLowerCase() === "select") {
      value = input.selectedOptions[0].disabled ? null : input.value;
    } else {
      value = input.type == "checkbox" ? input.checked : input.value;
    }

    const [valid, messages] = this.isValid(value, rules);

    this.handleErrorMessage(valid, input, messages);

    return [valid, messages];
  }

  // Validation logic
  validate() {
    if ([1, 2, 3].includes(this.currentStep)) {
      const stepContainer = document.querySelector(`.step-${this.currentStep}`);

      let errors = [];

      const inputs = stepContainer.querySelectorAll("input");
      const selects = stepContainer.querySelectorAll("select");

      let firstInputWithError = null;
      let firstSelectWithError = null;

      Array.from(inputs).forEach((input) => {
        const [valid, messages] = this.singleValidation({ target: input });

        errors = errors.concat(messages);

        if (!valid && !firstInputWithError) firstInputWithError = input;
      });

      Array.from(selects).forEach((select) => {
        const [valid, messages] = this.singleValidation({ target: select });

        errors = errors.concat(messages);

        if (!valid && !firstSelectWithError) firstSelectWithError = select;
      });

      // Scroll to the first element in the viewport that have an error
      if (errors.length > 0) {
        const numbers = [firstInputWithError, firstSelectWithError]
          .filter(Boolean)
          .map((el) => {
            if (el.nodeName.toLowerCase() === "select") {
              return el.parentNode.getBoundingClientRect().y;
            }
            return el.getBoundingClientRect().y;
          });

        const min = Math.min(...numbers);

        window.scrollTo({
          top: window.scrollY + min - 150,
          behavior: "smooth",
        });
      }

      return errors.length <= 0;
    }

    return true;
  }

  incrementStep(e) {
    if (!e.target.classList.contains("next-step-no-validate")) {
      this.skipReferrer = false;
      if (!this.validate()) return;
    } else {
      // remove error message
      $(`.step-${this.currentStep}`)
        .find(".error-message")
        .remove();

      this.skipReferrer = true;
    }

    if (this.currentStep + 1 > this.lastStep) return;
    this.next = true;
    this.currentStep++;
    this.goToCorrectStep();
  }

  decrementStep() {
    if (this.currentStep - 1 < 1) return;
    this.next = false;
    this.currentStep--;
    this.goToCorrectStep();
  }

  async tryToAuthenticate() {
    try {
      const response = await fetch(
        "https://api.sirio.chiron.ai/api/v1/auth/check_login",
        {
          credentials: "include",
        }
      );
      const json = await response.json();
      this.user = json;
    } catch (e) {}

    // console.log(this.user);

    // Autocomplete all azienda fields from user is already logged in
    if (this.user.auth) {
      jQuery(`input[name="partner[ragione_sociale]"]`).val(
        this.user.user.corporate
      );

      jQuery(`input[name="partner[name]"]`).val(this.user.user.firstname);
      jQuery(`input[name="partner[email]"]`).val(this.user.user.email);
      jQuery(`input[name="partner[phone]"]`).val(this.user.user.phone);

      if (this.user.user.sei) {
        jQuery(`select[name="sei"]`).val(this.user.user.sei);
        jQuery(`select[name="sei"]`).customSelect("reset");
      }

      if (this.user.user.database) {
        jQuery(`input[name="ecommerce_number"]`).val(this.user.user.database);
      }
    }
  }

  setInitialStep() {
    // jump the account creation step if authenticated
    if (this.user.auth) this.currentStep = 1;
    else this.currentStep = 1;
  }

  goToCorrectStep() {
    if (this.currentStep == 3) {
      this.printMarkup();
    }

    this.animate(...this.getCorrectClassNameBaseOnCurrentStep());
  }

  maybeUpdateTab() {
    if ([2, 3, 4].includes(this.currentStep)) {
      document.querySelector(".tabs-container").style.transition =
        "opacity 1s .7s";

      document.querySelector(".tabs-container").classList.remove("opacity-0");

      const map = [2, 3, 4];
      document.querySelectorAll(".tabs__item").forEach((tab, index) => {
        if (map[index] === this.currentStep) {
          tab.classList.add("tabs__item--active");
        } else {
          tab.classList.remove("tabs__item--active");
        }
      });
    }

    if (this.currentStep >= 5) {
      document.querySelector(".tabs-container").style.transition = "unset";
      document.querySelector(".tabs-container").classList.add("opacity-0");
    }
  }

  maybeChangeText() {
    if ([2, 3, 4, 5].includes(this.currentStep)) {
      const map = [2, 3, 4, 5];

      const titles = JSON.parse(this.titleBanner.dataset.title);
      const subTitles = JSON.parse(this.subtitleBanner.dataset.subtitle);

      this.titleBanner.textContent = titles[map.indexOf(this.currentStep)];
      this.subtitleBanner.textContent =
        subTitles[map.indexOf(this.currentStep)];
    }
  }

  getCorrectClassNameBaseOnCurrentStep() {
    if (this.hasLoaderActive && this.user.auth) {
      this.hasLoaderActive = false;
      return [".loader-container", ".steps"];
    }

    if (this.hasLoaderActive && !this.user.auth) {
      this.hasLoaderActive = false;
      // return [".loader-container", ".first-page"];
      return [".loader-container", ".steps"];
    }

    // if (this.currentStep === 2 && this.next) {
    //   return [`.step-1`, ".step-2"];
    // }

    // if (this.currentStep === 2 && !this.next) {
    //   return [".step-3", `.step-2`];
    // }

    if (this.currentStep < this.lastStep) {
      return [`.step-${this.currentStep - 1}`, `.step-${this.currentStep}`];
    }

    return [`.steps`, ".last-page"];
  }

  animate(exitingComponent, enteringComponent) {
    const exit = document.querySelector(exitingComponent);
    const enter = document.querySelector(enteringComponent);

    if (enteringComponent.includes("step") && this.currentStep != 3) {
      window.scrollTo({
        top: $(".steps").offset().top,
        behavior: "smooth",
      });
    }

    // this.maybeUpdateTab();
    this.maybeChangeText();

    if (
      enteringComponent === ".last-page" ||
      enteringComponent === ".first-page" ||
      exitingComponent === ".first-page" ||
      this.currentStep === 3
    ) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }

    setTimeout(() => {
      enter.classList.add("absolute");

      if (enteringComponent === ".steps" && this.currentStep < this.lastStep) {
        const childComponent = enter.querySelector(`.step-${this.currentStep}`);
        childComponent.classList.remove("hidden");
        childComponent.classList.remove("opacity-0");
      }

      if (
        enteringComponent === ".steps" &&
        this.currentStep === this.lastStep
      ) {
        const childComponent = enter.querySelector(`.step-${this.currentStep}`);
        childComponent.classList.add("hidden");
        childComponent.classList.add("opacity-0");
      }

      exit.classList.add("opacity-0");

      exit.addEventListener(
        "transitionend",
        (e) => {
          enter.classList.remove("hidden");

          setTimeout(() => {
            exit.classList.add("hidden");

            enter.classList.remove("absolute");
            enter.classList.remove("opacity-0");
          }, 100);
        },
        { once: true, capture: true }
      );
    }, 100);
  }
}

$(function() {
  new RequestQuote();
});
